/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Submitted_TextInputs */



/**
* | output |
* | --- |
* | "Your embed job has been submitted. You will be notified when it is complete." |
*
* @param {Embed_Captions_Submitted_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_submitted_text = /** @type {((inputs?: Embed_Captions_Submitted_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Submitted_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre tache d'incrustation a ete soumise. Vous serez notifie lorsqu'elle sera terminee.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Einbettungsauftrag wurde übermittelt. Sie werden benachrichtigt, sobald er abgeschlossen ist.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il tuo lavoro di incorporamento è stato inviato. Riceverai una notifica al termine.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ваша заявка на встраивание отправлена. Вы получите уведомление, когда она будет завершена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tu trabajo de inserción se ha enviado. Recibirás una notificación cuando esté completo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您的嵌入任务已提交。完成后，您将收到通知。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("埋め込みジョブが送信されました。完了すると通知されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपका एम्बेड जॉब सबमिट हो गया है। पूरा होने पर आपको सूचित किया जाएगा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seu pedido de incorporação foi enviado. Você será notificado quando estiver concluído.")
	return /** @type {LocalizedString} */ ("Your embed job has been submitted. You will be notified when it is complete.")
});